import { jsx } from "react/jsx-runtime";
import { validateTidalLicense } from "@workwave-tidal/core/base";
import { FormRoot, useCreateForm } from "@workwave-tidal/form-fairy";
function FormProvider(props) {
  const { name, config, fields, verbose, children, resetMode } = props;
  const formState = useCreateForm(name, fields, config, resetMode, verbose);
  return /* @__PURE__ */ jsx(FormRoot, { formState, children });
}
validateTidalLicense();
export {
  FormProvider
};
//# sourceMappingURL=FormProvider.js.map
